//@从气导那边获取船舶、航线等信息等接口
import request from '../../request/screenRequest';

// 获取山东海运全部船舶的位置信息
export function getShips() {
  return request({
    method: 'get',
    url: 'api/proxy/ocean/sp/ships/position/open'
  });
}

// 获取船舶的航线信息
export function getShipTrack(mmsi) {
  return request({
    method: 'get',
    url: `api/proxy/ocean/sp/ships/${mmsi}/routes/open`,
  });
}

export function getAssembleRoutes(data) {
  return request({
    method: 'get',
    url: `api/proxy/ocean/bl/forms/${data.formId}/assembleRoutes`,
    params: {meteo_interval: 12}
  })
}

// 获取推演航线信息
export function getShipDeduce(mmsi) {
  return request({
    method: 'get',
    url: `api/proxy/ocean/rt/dynamicRouters/forms/${mmsi}/deduce`,
  });
}

// 获取全航程航线信息
export function getPlanRouteAll(params) {
  return request({
    method: 'get',
    url: `api/proxy/ocean/rt/dynamicRouters`,
    params
  });
}


// 获取推演台风信息
export function getTyphoonDeduce() {
  return request({
    method: 'get',
    url: `api/proxy/meteo/typhoon/v2/forecast/newest`,
  });
}

// 获取船舶的航线预警
export function getShipWarnList(mmsi, imo) {
  return request({
    method: 'get',
    url: `api/proxy/meteo/wind/warning/${imo}/${mmsi}`,
  });
}
// AIS 历史数据
export function getShipAisList(data) {
  return request({
    method: 'post',
    url: '/api/ais/track',
    data
  });
}


